export default __webpack_public_path__ + "static/media/bg-explore.a622bc74.jpg";